// DEPRECATED
export enum OrderStatus{
    PendingNewRisk = 10,
    PendingNewTradeConnector = 11,
    PendingReplaceRisk = 12,
    PendingReplaceTradeConector = 13,
    PendingCancelRisk = 14,
    PendingCancelTradeConector = 15,
    PendingNewExchange = 16,
    PendingReplaceExchange = 17,
    PendingCancelExchange = 18,
    PendingTrigger = 19,
    New = 48,
    PartiallyFilled = 49,
    Filled = 50,
    Cancelled = 52,
    Replaced = 53,
    Rejected = 56,
    Suspendend = 57,
    Expired = 67,
    PreviousFinalState = 90,
    CanceledByEndDayRoutine = 94,
    CanceledByShutdownStrategy = 95,
    CanceledByEvent = 96,
    ScheduledReplacement = 97,
    ScheduledCancelation = 98,
    ScheduledNew = 99,

    // Wrong:
    TurnOnPlanned = 94,
}


export enum ExchangeOrderStatus {
    PendingNewRisk = 10,
    PendingNewTradeConnector = 11,
    PendingReplaceRisk = 12,
    PendingReplaceTradeConector = 13,
    PendingCancelRisk = 14,
    PendingCancelTradeConector = 15,
    PendingNewExchange = 16,
    PendingReplaceExchange = 17,
    PendingCancelExchange = 18,
    PendingTrigger = 19,
    New = 48,
    PartiallyFilled = 49,
    Filled = 50,
    Cancelled = 52,
    Replaced = 53,
    Rejected = 56,
    Suspendend = 57,
    Expired = 67,
    PreviousFinalState = 90,
    CanceledByEndDayRoutine = 94,
    CanceledByShutdownStrategy = 95,
    CanceledByEvent = 96,
    ScheduledReplacement = 97,
    ScheduledCancelation = 98,
    ScheduledNew = 99,
}